import ResyCreditBanner from './ResyCreditBanner';

export default ResyCreditBanner;
